import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { TableColumnType } from "src/app/constants/table";
import { BenefitTotal } from "src/app/models/benefit-summary";
import { MemberBenefitCard, MemberBenefitFlyout } from "src/app/models/enrollment-option";
import { TableColumn } from "src/app/models/table";

@Component({
    selector: 'mwp-deduction-summary',
    templateUrl: './deduction-summary.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DeductionSummaryComponent implements OnInit {
    @Input() public memberBenefitFlyout: MemberBenefitFlyout;
    @Input() public displayTotalCard: boolean;
    @Input() public benefitTotal: BenefitTotal;
    @Input() public totalCardMessageHTML: string;
    @Input() public isNoBorder: boolean = true;

    public amountWidth: string = '15%';

    public benefitMatTableData: MatTableDataSource<MemberBenefitCard>;
    public benefitColumns: TableColumn[] = [
        {
            columnName: 'Benefit Name',
            propertyId: 'memberBenefitName',
            columnType: TableColumnType.label,
        },
        {
            columnName: 'Pre Tax',
            propertyId: 'pretaxAmount',
            columnType: TableColumnType.label,
            width: this.amountWidth,
            cssCustomHeaderClass: 'd-flex justify-content-end',
            cssCustomClass: 'd-flex justify-content-end'
        },
        {
            columnName: 'Post Tax',
            propertyId: 'posttaxAmount',
            columnType: TableColumnType.label,
            width: this.amountWidth,
            cssCustomHeaderClass: 'd-flex justify-content-end pe-2',
            cssCustomClass: 'd-flex justify-content-end pe-2'
        },
    ];

    ngOnInit(): void {
        this.benefitMatTableData = new MatTableDataSource<MemberBenefitCard>();
        this.benefitMatTableData.data = this.memberBenefitFlyout?.memberBenefitCards;
    }
}